/**
 * Tracks product page landings that originate from quiz recommendations.
 */

/**
 * @param {string | null} value
 * @returns {string}
 */
const normalizeEventPrefix = (value) => {
  const normalized = String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, '_')
    .replace(/[^a-z0-9_]/g, '')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '');

  return normalized ? `${normalized}_` : '';
};

/**
 * @param {string} prefix
 * @param {string} eventName
 * @returns {string}
 */
const prefixedEventName = (prefix, eventName) => {
  const baseEventName = String(eventName || '').replace(/^quiz_/, '');

  return `${normalizeEventPrefix(prefix || 'swimwear_quiz_')}${baseEventName}`;
};

const trackQuizProductLanding = () => {
  const url = new URL(window.location.href);
  const quizId = url.searchParams.get('quiz_id');
  const quizRecommendation = url.searchParams.get('quiz_reco');

  if (!quizId || !quizRecommendation || !url.pathname.includes('/products/')) return;

  const eventPrefix = normalizeEventPrefix(url.searchParams.get('quiz_event_prefix') || 'swimwear_quiz_');
  const itemListId = url.searchParams.get('quiz_item_list_id') || 'swimwear_product_quiz_results';
  const itemListName = url.searchParams.get('quiz_item_list_name') || 'Swimwear quiz results';
  const productHandle = url.pathname.split('/products/')[1]?.split('/')[0] || '';
  const eventName = prefixedEventName(eventPrefix, 'quiz_product_landing');
  const payload = {
    event_base: 'quiz_product_landing',
    event_prefix: eventPrefix,
    event_title: eventName,
    item_index: url.searchParams.get('quiz_item_index') || '',
    item_list_id: itemListId,
    item_list_name: itemListName,
    landing_product_handle: productHandle,
    page_path: url.pathname,
    quiz_id: quizId,
    quiz_reco: quizRecommendation,
    render_context: url.searchParams.get('quiz_render_context') || '',
    tier: url.searchParams.get('quiz_tier') || '',
    variant_id: url.searchParams.get('variant') || '',
  };

  try {
    window.sessionStorage?.setItem(
      'wukaQuizItemListContext',
      JSON.stringify({
        item_list_id: itemListId,
        item_list_name: itemListName,
        product_handle: quizRecommendation || productHandle,
      })
    );
  } catch (error) {
    // Keep tracking even when storage access is blocked.
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, ...payload });

  if (typeof console.groupCollapsed === 'function') {
    console.groupCollapsed('[WUKA Quiz GA4] quiz_product_landing');
    console.log(payload);
    console.groupEnd();
  } else {
    console.log('[WUKA Quiz GA4] quiz_product_landing', payload);
  }

  const shopifyAnalytics = window.Shopify?.analytics;
  if (typeof shopifyAnalytics?.publish === 'function') shopifyAnalytics.publish(eventName, payload);

  for (const param of [
    'quiz_id',
    'quiz_reco',
    'quiz_event_prefix',
    'quiz_render_context',
    'quiz_tier',
    'quiz_item_list_id',
    'quiz_item_list_name',
    'quiz_item_index',
  ]) {
    url.searchParams.delete(param);
  }

  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
};

trackQuizProductLanding();
